import './HandCards.css';
import HandCards from './HandCards';
export default HandCards;



// WEBPACK FOOTER //
// ./src/components/Game/components/HandCards/index.js